// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"139":"f1a54dfa","453":"14728b7d","466":"f1a54734"}[chunkId] + ".chunk.js";
};